module.exports = __webpack_public_path__ + "static/img/adverst.c81338e0.png";